/*
 * Copyright (c) 2021. Michael Clovis
 * This program is free software: you can redistribute it and/or modify
 *     it under the terms of the GNU Affero General Public License as published by
 *     the Free Software Foundation, either version 3 of the License, or
 *     (at your option) any later version.
 *
 *     This program is distributed in the hope that it will be useful,
 *     but WITHOUT ANY WARRANTY; without even the implied warranty of
 *     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *     GNU Affero General Public License for more details.
 *
 *     You should have received a copy of the GNU Affero General Public License
 *     along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

export class Job{
  DEFAULT_ID = "0";
  id = this.DEFAULT_ID;
  name = ""
  constructor(name) {
    this.name = name;
  }

  static convertObject(obj){
    let job = new Job();
    job = Object.assign(job,obj);
    return job;
  }
  toJson(){

    return JSON.stringify(this);
  }
}

